import { InquiryForm } from "../components/InquiryForm";
import { ShopMap } from "../components/ShopMap";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { useSeo } from "../lib/useSeo";
import { useSettings, AddressLines } from "../lib/settings";

export default function Contact() {
  const { settings } = useSettings();
  useSeo({ title: "Contact Us", description: `Visit ${settings.company_name} at ${(settings.shop_address || "").split("\n").join(" ")}. Call or send an inquiry for a free solar site visit.` });
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16">
      <div className="mb-12">
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-primary mb-3">Contact</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight">
          Let's talk about <br />going solar.
        </h1>
      </div>

      <div className="grid lg:grid-cols-2 gap-10">
        <div className="space-y-6">
          <div className="bg-white border border-border rounded-2xl p-6 flex gap-4 items-start" data-testid="contact-address-block">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
              <MapPin className="w-6 h-6 text-primary" strokeWidth={1.75} />
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.15em] font-bold text-muted-foreground mb-1">Shop Address</div>
              <div className="font-heading text-lg font-semibold leading-snug" data-testid="contact-address">
                <AddressLines text={settings.shop_address} />
              </div>
            </div>
          </div>
          <div className="bg-white border border-border rounded-2xl p-6 flex gap-4 items-start">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
              <Phone className="w-6 h-6 text-primary" strokeWidth={1.75} />
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.15em] font-bold text-muted-foreground mb-1">Call Us</div>
              <a href={`tel:${(settings.shop_phone || "").replace(/[^\d+]/g, "")}`} className="font-heading text-lg font-semibold hover:text-primary" data-testid="contact-phone">{settings.shop_phone}</a>
            </div>
          </div>
          <div className="bg-white border border-border rounded-2xl p-6 flex gap-4 items-start">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
              <Mail className="w-6 h-6 text-primary" strokeWidth={1.75} />
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.15em] font-bold text-muted-foreground mb-1">Email</div>
              <a href={`mailto:${settings.shop_email}`} className="font-heading text-lg font-semibold hover:text-primary break-all" data-testid="contact-email">{settings.shop_email}</a>
            </div>
          </div>
          <div className="bg-white border border-border rounded-2xl p-6 flex gap-4 items-start">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
              <Clock className="w-6 h-6 text-primary" strokeWidth={1.75} />
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.15em] font-bold text-muted-foreground mb-1">Shop Hours</div>
              <div className="font-heading text-lg font-semibold" data-testid="contact-hours">{settings.shop_hours}</div>
            </div>
          </div>
        </div>

        <div className="bg-white border border-border rounded-2xl p-8">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-primary mb-2">Enquiry form</div>
          <h2 className="font-heading text-3xl font-bold tracking-tight mb-6">Send us a message</h2>
          <InquiryForm />
        </div>
      </div>

      <section className="mt-12">
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-primary mb-2">Find us</div>
        <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight mb-6">Navigate to our shop.</h2>
        <ShopMap className="h-[380px] sm:h-[440px]" />
      </section>
    </div>
  );
}
